const api_key = "ae049e9be71b47678494e73d3999f277";

export default api_key;
